import { 
    DocumentSignedJsonResponse, 
    DownloadDrlDocumentJsonResponse, 
    DownloadESignedDocumentJsonResponse, 
    ReturnStatusJsonResponse, 
    TestConnectionJsonResponse, 
    EngagementLetterSignedAndOrganizerCompletedJsonResponse, 
    SourceDocumentUploadedJsonResponse, 
    AccessedOrganizerNotificationJsonResponse, 
    QuestionnaireCompletedJsonResponse, 
    GTR_DownloadEsignDocumentsJsonResponse, 
    GTR_DownloadFillableOrganizerJsonResponse, 
    GTR_DownloadSourceDocumentsJsonResponse, 
    ClientInformationJsonResponse, 
    SignatureStatusJsonResponse } from "../../common/model/webhookJsonResponse"

export const testConnectionJsonResponse: TestConnectionJsonResponse = {
    eventType: 0,
    message: "Test Connection"
}

export const clientInformationJsonResponse: ClientInformationJsonResponse = {
    eventType: 5001,
    eventData: {
        uId: "123",
        clientId: "Test_clientID",
        ero: "Macxin Poulose",
        location: "Safe Send",
        type: "Taxpayer",
        mfj: true,
        taxpayer: {
            name: "Jack Anderson",
            email: "Jackanderson@exampke.com",
            mobile: "9000000000",
            countryCode: "+91",
            ssn: "659998747"
        },
        spouse: {
            name: "Jill Anderson",
            email: "Jillanderson@exampke.com",
            mobile: "9000000001",
            countryCode: "+91",
            ssn: "659998745"
        },
        actionDate: "2024-10-22T03:40:35.0492286Z",
        actionType: "Edit"
    }
}

export const GTR_downloadEsignDocumentsJsonResponse: GTR_DownloadEsignDocumentsJsonResponse = {
    eventType: 6000,
    eventData: {
        gatherId: 2345,
        taxpayerName: "Jack Murphy",
        spouseName: "Jane Murphy",
        clientId: "newClientId",
        taxpayerEmail: "amit@gmail.com",
        spouseEmail: "sejal@gmail.com",
        taxYear: 2022,
        eroSigner: "Morgan",
        assignedTo: "Claire",
        uniqueArgs: "",
        documentFile: {
            fileName: "2021_EL.pdf",
            sasUrl: "https://www.documentstore.com/filename.pdf"
        }
    }
}

export const GTR_downloadFillableOrganizerJsonResponse: GTR_DownloadFillableOrganizerJsonResponse = {
    eventType: 6001,
    eventData: {
        gatherId: 2345,
        taxpayerName: "Jack Murphy",
        spouseName: "Jane Murphy",
        clientId: "newClientId",
        taxpayerEmail: "amit@gmail.com",
        spouseEmail: "sejal@gmail.com",
        taxYear: 2022,
        eroSigner: "Morgan",
        assignedTo: "Claire",
        uniqueArgs: "",
        documentFile: {
            fileName: "2021_EL.pdf",
            sasUrl: "https://www.documentstore.com/filename.pdf"
        }
    }
}

export const GTR_downloadSourceDocumentsJsonResponse: GTR_DownloadSourceDocumentsJsonResponse = {
    eventType: 6002,
    eventData: {
        gatherId: 2345,
        clientId: "newClientId",
        clientName: "Jack Murphy",
        taxpayerEmail: "amit@gmail.com",
        assignedTo: "Claire",
        eroSigner: "Morgan",
        engagementType: "E1040",
        taxYear: 2022,
        batchName: "Batch1",
        spouseName: "Jane Murphy",
        spouseEmail: "sejal@gmail.com",
        uniqueArgs: "",
        documentFile: {
            fileName: "2021_EL.pdf",
            sasUrl: "https://www.documentstore.com/filename.pdf"
        }

    }
}

export const signatureStatusJsonResponse  : SignatureStatusJsonResponse = {
    eventType : "3001",
    eventData :{
        clientId : "Chrisst12",
        clientName : "Chriss user",
        documentInfo: [
            {
				documentType: "Engagement Letter",
				documentId: "RAJV5A9LKRW4J10D32VXV0AUTW"
            }
        ],
        sentBy: "TestingAdmin@safesend.com",
		officeLocation: "G34",
		signatureId: "6RVJNLDP06F412Q4L5LPLMUD6H",
		status: "Processing",
		taxYear: 2025,
		totalRecipients: 2,
		uniqueArgs: "unique argument",
		statusDate: "01/22/2025"
    }    
}

export const documentSignedJsonResponse: DocumentSignedJsonResponse = {
    eventType: 3000,
    eventData: {
        clientId: "client_post_test_demo",
        clientName: "demo_client",
        taxYear: 2021,
        sentBy: "noreply@safesend.com",
        totalRecipients: 2,
        recipientList: [
            "user1@gmail.com",
            "user2@gmail.com"
        ],
        delegateeList: [
            "user3@gmail.com",
            "user4@gmail.com"
        ],
        signatureStatus: "PartiallySigned/ESigned",
        uniqueArgs: "unique value",
        signedFiles: [
            {
                fileName: "filename1.pdf",
                sasUrl: "https://www.documentstore.com/filename1.pdf",
                expiresOn: "2038-02-08T00:00:00",
                documentType: "Engagement Letter",
                documentGuid: "ca9bbe9d-1cf5-4037-845d-29ff537b06c0",
                documentId: 152
            },
            {
                fileName: "filename2.pdf",
                sasUrl: "https://www.documentstore.com/filename2.pdf",
                expiresOn: "2038-02-08T00:00:00",
                documentType: "Consent Form",
                documentGuid: "ca9bbe9d-1cf5-4037-845d-29ff537b06c1",
                documentId: 153
            }
        ]
    }
}

export const downloadDrlDocumentJsonResponse: DownloadDrlDocumentJsonResponse = {
    eventType: 4000,
    eventData: {
        documentRequestListId: "35fcbf38-924f-48f9-8a12-276fc484b817",
        clientEmailId: "steve.smith@safesend.com",
        documentFieldName: "Steve Smith",
        uploadedDate: "08/10/2023",
        uniqueArgs: "Upload Complete",
        document: {
            name: "invoice.pdf",
            sasUrl: "https://www.documentstore.com/filename.pdf"
        }
    }
}

export const engagementLetterSignedAndOrganizerCompletedCommonJsonResponse = {
    eventData: {
        taxPayerName: "Ashish Rathi",
        clientId: "client_post_test_demo",
        taxPayerEmail: "ashish@safesend.com",
        taxYear: 2021,
        eroSigner: "Demo User1",
        assignedTo: "Demo User2",
        uniqueArgs: "",
        documentFile: {
            fileName: "filename.pdf_or_filename.zip",
            sasUrl: "https://www.documentstore.com/filename.pdf"
        },
        documentGuid: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        organizerId: "1KV9JWK448YMEGGYJLQE3HZQH4"
    }
}

export const engagementLetterSignedJsonResponse:EngagementLetterSignedAndOrganizerCompletedJsonResponse = {
    eventType: 2000,
    ...engagementLetterSignedAndOrganizerCompletedCommonJsonResponse
}

export const OrganizerCompletedJsonResponse:EngagementLetterSignedAndOrganizerCompletedJsonResponse = {
    eventType: 2001,
    ...engagementLetterSignedAndOrganizerCompletedCommonJsonResponse
}

export const sourceDocumentUploadedJsonResponse: SourceDocumentUploadedJsonResponse = {
    eventType: 2002,
    eventData: {
        taxPayerName: "Ashish Rathi",
        clientId: "client_post_test_demo",
        taxPayerEmail: "ashish@safesend.com",
        taxYear: 2021,
        eroSigner: "Demo User1",
        assignedTo: "Demo User2",
        uniqueArgs: "",
        documentFile: {
            fileName: "filename.pdf_or_filename.zip",
            sasUrl: "https://www.documentstore.com/filename.pdf"
        },
        uploadedOn: "2022-12-14T02:36:19.494Z",
        documentGuid: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        organizerId: "1KV9JWK448YMEGGYJLQE3HZQH4"
    }
}

export const accessedOrganizerNotificationJsonResponse: AccessedOrganizerNotificationJsonResponse = {
    eventType: 2003,
    eventData: {
        taxPayerName: "Ashish Rathi",
        clientId: "client_post_test_demo",
        taxPayerEmail: "ashish@safesend.com",
        taxYear: 2021,
        batchName: "Demo Batch",
        accessedOn: "2022-12-14T02:36:19.494Z ",
        uniqueArgs: "",
        organizerId: "1KV9JWK448YMEGGYJLQE3HZQH4"
    }
}

export const questionnaireCompletedJsonResponse: QuestionnaireCompletedJsonResponse = {
    eventType: 2004,
    eventData: {
        uniqueArgs: "",
        documentFile: {
            fileName: "filename.pdf_or_filename.zip",
            sasUrl: "https://www.documentstore.com/filename.pdf"
        },
        taxPayerName: "Jannet Doe",
        taxPayerEmail: "gantest2@yopmail.com",
        clientId: "OrganizerWithELAndSpouse",
        taxYear: 2023,
        eroSigner: "Demo User1",
        assignedTo: "Demo User2",
        documentGuid: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        organizerId: "1KV9JWK448YMEGGYJLQE3HZQH4"
    }
}

export const downloadESignedDocumentJsonResponse: DownloadESignedDocumentJsonResponse = {
    "documentStatus": "USERSIGNED",
    "signatureStatus": "ESigned",
    "signedOn": "2023-07-03T06:23:13.3566291Z",
    "taxSoftware": "ProSystems",
    "deliveredOn": "2023-06-29T05:27:16.977",
    "taxYear": 2022,
    "engagementType": "E1120",
    "documentClients": [
        {
            "clientType": "PartnerShip",
            "name": "ENERGY AUDITORS",
            "email": "useremail@safesend.com",
            "ssn": "999999991"
        }
    ],
    "signedEFiles": [
        {
            "fileName": "Efile1.pdf",
            "fileSAS": "https://www.documentstore.com/Efile1.pdf"
        }
    ],
    "additionalESignedFiles": [
        {
            "fileName": "Efile2.pdf",
            "fileSAS": "https://www.documentstore.com/Efile2.pdf"
        }
    ],
    "documentGuid": "fd48d692-ac8d-49e0-91c2-982ea5100bab",
    "documentId": 79,
    "clientId": "1120AK",
    "httpStatus": 200,
    "message": "success.",
    "uniqueArgs": "Additional Data",
    "taxReturnId": "LCRKJF8TVXG47AT5E0YU6RYKYW"
}

export const returnStatusChangeJsonResponse: ReturnStatusJsonResponse = {
    status: "PROCESSING",
    statusDate: "2022-12-20T07:14:58.9708711Z",
    eroEmail: "user1@safesend.com",
    assignedEmail: "user2@safesend.com",
    formType: "E1040",
    taxYear: 2021,
    documentGuid: "53e12ecb-f233-429e-882d-59018a7ee8b2",
    documentId: 147857,
    clientId: "client_demo",
    httpStatus: 0,
    uniqueArgs: "Additional Data",
    taxReturnId: "LCRKJF8TVXG47AT5E0YU6RYKYW"
}
